export default __webpack_public_path__ + "static/media/dow.f943f8fa.jpg";